import React, { useMemo } from 'react';
import ImageBase from '../../atoms/ImageBase/ImageBase';
import VideoCard from '../VideoCard/VideoCard';
import ReactMarkdown from 'react-markdown';
import Link from 'next/link';
import { withHostPath } from '../../../helper/getBasePath';

interface ITeaserCard {
    bgImage: string;
    title?: string;
    text?: string;
    ctaLabel?: string;
    ctaLink?: string;
    ignoreBasePath?: boolean;
    youtubeUrl: string | null;
}

export const CardMd: React.FC<ITeaserCard> = ({
    bgImage = '',
    title = '',
    text = '',
    ctaLink,
    ctaLabel,
    ignoreBasePath = false,
    youtubeUrl = null,
}) => {
    const finalHref = useMemo(() => {
        const link = ctaLink?.replace('https://www.marketingcenter.remax.eu', '') ?? '';

        if (link.includes('content.php')) {
            const regex = /content\.php\?category=(\d+)/;
            const result = link.match(regex);
            const id = result?.[1] ?? '0';
            return `/category/${id}`;
        }

        return withHostPath(link);
    }, [ctaLink]);
    return (
        <div className="relative flex h-full w-full flex-col gap-0">
            {youtubeUrl && (
                <>
                    <VideoCard url={youtubeUrl ?? ''} title={title} />
                </>
            )}

            {!youtubeUrl && bgImage && finalHref && (
                <Link href={finalHref} className="aspect-w-1 aspect-h-1 relative h-full w-full">
                    <ImageBase
                        className="transition-all duration-1000 hover:scale-105"
                        src={bgImage}
                        alt="Teaser Image"
                        layout="fill"
                        objectFit="cover"
                        ignoreBasePath={ignoreBasePath}
                        placeholder="blur"
                        // https://png-pixel.com/
                        blurDataURL="/shop/images/blur/1x1-dcdcdc51.png"
                    />
                </Link>
            )}

            <div className="min-h-16 relative flex flex-col bg-gray-100 p-6">
                {title?.length > 0 && (
                    <div className="min-h-32 relative flex flex-col">
                        <h3 className="text-lg font-medium text-primary">{title}</h3>
                        <div className="min-h-12 mt-2 mb-7 text-sm text-gray-500">
                            <ReactMarkdown>{text}</ReactMarkdown>
                        </div>
                    </div>
                )}
                {ctaLabel && (
                    <div className="relative flex w-full flex-row justify-end">
                        <a className="buttonDefault" href={ctaLink} target="_parent">
                            {ctaLabel}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
